(function ($) {
    $(document).ready(function () {
        offersGrid();
        select2();
    });

    function select2() {
        $('#offers-select').select2(
            {}
        );
    }

    function offersGrid() {
        var isMobile = window.matchMedia('(max-width: 991px)');
        var wrap = $('.children_previews .wrap.grid .inner_wrapper ');
        if (wrap.length > 0) {
            var itemHeight = wrap.find('.item_wrap').eq(0).outerHeight();
            var wrapHeight = wrap.outerHeight(true);
            var startWrapHeight = isMobile.matches ? (itemHeight * 6 -10) : (itemHeight * 2 - 10);
            var btnWrap = $('#load_more_wrap');
            var btnLoadMoreAfterHeight = 10;
            var btnWrapHeight = btnWrap.outerHeight(true) + btnLoadMoreAfterHeight;
            var btnLoadMore = $('.load_more');

            function offersFilter() {
                // Init Isotope
                var filterselect = $('#offers-select');
                if (filterselect.length) {
                    var grid = $('.inner_wrapper');
                    grid.isotope({
                        itemSelector: '.item_wrap',
                        layoutMode: 'fitRows',
                        transitionDuration: '0.6s',
                        transformsEnabled: true,
                        filter: '.filter_all',
                    });


                    // Bind filter on select change
                    filterselect.on('change', function () {
                        var value = $(this).val();
                        // Get filter value from option value
                        grid.isotope({filter: value});
                        setTimeout(function () {
                            // Delete Hidden Elements with display none, remove white space footer
                            jQuery('.item[style*="opacity: 0"]').css('display', 'none');
                        }, 200)
                        // Adjust wrapHeight and reset btnLoadMore
                        setTimeout(function () {
                            wrapHeight = wrap.outerHeight(true);
                            if (btnLoadMore.hasClass('open')) {
                                closeLoadMoreView(wrapHeight);
                            }
                            galleryHeight();
                        }, 500);
                    });
                }

            }

            function appendMoreLi() {
                if (btnLoadMore.children().length < 1) {
                    btnLoadMore.append('<span class="more_li"></span>');
                }
            }

            function galleryHeight() {
                if (wrapHeight > startWrapHeight) {
                    wrap.css({
                        height: startWrapHeight,
                        'overflow': 'hidden'
                    });
                    btnWrap.show();
                } else {
                    btnWrap.hide();
                }
            }

            function closeLoadMoreView(height) {
                btnLoadMore.removeClass('open');
                btnLoadMore.text('load more');
                appendMoreLi();
                wrap.css({
                    height: height
                });
            }

            function loadMoreView() {
                btnLoadMore.click(function () {
                    if (btnLoadMore.hasClass('open')) {
                        closeLoadMoreView(startWrapHeight);
                        var wrapOffsetTop = wrap.offset().top + ((startWrapHeight) - (itemHeight + btnWrapHeight));
                        $('html, body').animate({
                            scrollTop: wrapOffsetTop
                        }, 10);
                    } else {
                        btnLoadMore.addClass('open');
                        $(this).text(view_less)
                        appendMoreLi();
                        wrap.css({
                            height: (wrapHeight)
                        });
                    }
                });
            }

            offersFilter();
            galleryHeight();
            appendMoreLi();
            loadMoreView();
        }
    }

}(jQuery));